import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Alarm } from '../models/dashboard-data.model';

@Injectable({ providedIn: 'root' })
export class AlarmsService {
  private http = inject(HttpClient);

  getAlarms(state: 'all' | 'active' | 'ceased' | 'acknowledged' = 'all'): Observable<Alarm[]> {
    return this.http.get<Alarm[]>(environment.api.alarms, { params: { state } });
  }

  acknowledgeAlarm(alarmId: string): Observable<void> {
    return this.http.put<void>(`${environment.api.baseUrl}/alarms/acknowledge/${alarmId}`, {});
  }

  resetAlarm(alarmId: string): Observable<void> {
    return this.http.put<void>(`${environment.api.baseUrl}/alarm/reset/${alarmId}`, {});
  }
}
